





























import { typedStore } from '@/store';
import Vue from 'vue';

export default Vue.extend({
  name: 'HeaderActionDispatcher',
});
